import { AuthenticatedRoutesType } from './routes';
import { RolesType } from '../Authorization/AuthorizationWrapper';
import { canApproveLetterOfCredit, canCreateLetterOfCredit } from '../Authorization/moduleActionRestrictions';

export type RoutePermission = {
    allowedRoles?: RolesType | RolesType[];
    restrictedRoles?: RolesType | RolesType[];
};

type RoutePermissions = {
    [key in AuthenticatedRoutesType]?: RoutePermission;
};

export const Permissions: RoutePermissions = {
    DASHBOARD: undefined,

    // Creating and amending an LC application. Viewing one is deliberately open:
    // anyone who can see the account's trade finance can read its applications.
    LETTER_OF_CREDIT: { allowedRoles: canCreateLetterOfCredit },
    EDIT_LETTER_OF_CREDIT: { allowedRoles: canCreateLetterOfCredit },
    AMEND_LETTER_OF_CREDIT: { allowedRoles: canCreateLetterOfCredit },

    // Raising a shipping guarantee is raising a request; deciding on one is a
    // bank act, so the review screen follows the approver list.
    NEW_SHIPPING_GUARANTEE: { allowedRoles: canCreateLetterOfCredit },
    VIEW_SHIPPING_GUARANTEE: { allowedRoles: [...canCreateLetterOfCredit, ...canApproveLetterOfCredit] },
};
